import { CFooter } from './CFooter.js';

const CFooterPlugin = {
    install: (app) => {
        app.component(CFooter.name, CFooter);
    },
};

export { CFooter, CFooterPlugin };
//# sourceMappingURL=index.js.map
